import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  selectedPlant: null
}

export default {
  state,
  mutations,
  actions,
  getters
}
